export default "__VITE_ASSET__CxbZYESt__"